const fileSize = (size: number) => {
  let sizeCategory;
  const absSize = Math.abs(size);

  switch (true) {
    case absSize < 1024:
      sizeCategory = `${(size / 1024).toFixed(2)} Byte`;
      break;
    case absSize >= 1024 && absSize < 1024 * 1024:
      sizeCategory = `${(size / 1024).toFixed(2)} KB`;
      break;
    case absSize >= 1024 * 1024 && absSize < 1024 * 1024 * 1024:
      sizeCategory = `${(size / (1024 * 1024)).toFixed(2)} MB`;
      break;
    default:
      sizeCategory = `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }

  return sizeCategory;
};

export { fileSize };
export default fileSize;
